import { Link as TanstackRouterLink, type LinkProps } from '@tanstack/react-router';
import { forwardRef } from 'react';
import { useRouteExists } from '@r/hooks/use-route-exists.ts';

export const LinkProtected = forwardRef<HTMLAnchorElement, LinkProps & { className?: string }>(
  ({ className, ...props }, ref) => {
    const routeExists = useRouteExists(props.to as string);
    if (!routeExists) {
      return null;
    }

    return <TanstackRouterLink ref={ref} {...props} className={className} />;
  }
);

LinkProtected.displayName = 'LinkProtected';
